import { render } from "./Index.vue?vue&type=template&id=a7f6c2f0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=a7f6c2f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a7f6c2f0"

export default script